module.exports = __webpack_public_path__ + "static/media/deal.07bcfa53.svg";